import { split } from '@apollo/client'
import { apolloAuthLink } from './apolloLink'
import { actionCableLink, hasSubscriptions } from './subscriptions'

const splitLink = split(hasSubscriptions, actionCableLink, apolloAuthLink)

export { splitLink }
